import { render, staticRenderFns } from "./OrderTagGroup.vue?vue&type=template&id=9de79adc&scoped=true"
import script from "./OrderTagGroup.vue?vue&type=script&lang=js"
export * from "./OrderTagGroup.vue?vue&type=script&lang=js"
import style0 from "./OrderTagGroup.vue?vue&type=style&index=0&id=9de79adc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de79adc",
  null
  
)

export default component.exports